(function () {
  'use strict';

    const IS_FR = document.documentElement.lang &&
    document.documentElement.lang.toLowerCase().startsWith('fr');

  // Préfixe déduit de l'URL réelle de la page (pas de la langue affichée),
  // pour que ça marche aussi sur les domaines où /en/ n'est pas routé (ex: lien .myshopify.com)
  const LOCALE_PREFIX = (window.location.pathname === '/en' || window.location.pathname.indexOf('/en/') === 0)
    ? '/en'
    : '';


  const T = {
    itemSingular:     IS_FR ? 'article'           : 'item',
    itemPlural:       IS_FR ? 'articles'          : 'items',
    shippingProgress: IS_FR ? 'Plus que {X} pour la livraison gratuite ✨' : '{X} away from free shipping ✨',
    shippingFree:     IS_FR ? '🎉 Livraison gratuite débloquée !' : '🎉 Free shipping unlocked!',
    emptyCart:        IS_FR ? 'Votre panier est vide' : 'Your cart is empty',
    remove:           IS_FR ? 'Retirer'           : 'Remove',
    upsellTitle:      IS_FR ? 'VOUS AIMEREZ AUSSI' : 'YOU MAY ALSO LIKE',
    quickView:        IS_FR ? 'Aperçu rapide'     : 'Quick view',
    taxesNote:        IS_FR ? 'Taxes incluses. <a href="/policies/shipping-policy">Frais d\'expédition</a> calculés à l\'étape du paiement.'
                            : 'Taxes included. <a href="/policies/shipping-policy">Shipping</a> calculated at checkout.',
    checkout:         IS_FR ? 'FINALISER LA COMMANDE' : 'CHECKOUT',
    inStock:          IS_FR ? 'En stock'          : 'In stock',
    sizeLabel:        IS_FR ? 'Taille'            : 'Size',
    addToCart:        IS_FR ? 'AJOUTER AU PANIER' : 'ADD TO CART',
    adding:           '…',
    error:            IS_FR ? 'Erreur — réessayez' : 'Error — try again',
    added:            IS_FR ? 'Article ajouté ✓'  : 'Item added ✓',
    loadError:        IS_FR ? 'Erreur de chargement' : 'Loading error',
    whereAreYou:      IS_FR ? 'Où êtes-vous ?'    : 'Where are you?',
    locationSub:      IS_FR ? 'Votre localisation nous permet d\'afficher les frais de livraison adaptés.'
                            : 'Your location helps us show the right shipping rates.',
    confirm:          IS_FR ? 'CONTINUER'         : 'CONTINUE',
    freeFrom:         IS_FR ? 'Gratuit dès'       : 'Free from',
  };

  const LV_CONFIG = {
    shipping: { FR: 10000, EU: 10000, HK: 8000, WORLD: 16000 },
    euCountries: ['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR',
      'HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE','CH'],
    brandName: 'LA VAGUE',
  };

  let lvCart = null;
  let lvCountry = localStorage.getItem('lv_country') || null;
  let lvSelectedVariant = null;

  /* ── UTILS ── */
  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2)
      .replace('.00', '')
      .replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0');
    return amount + '€';
  }

  function getShippingThreshold() {
    if (!lvCountry) return LV_CONFIG.shipping.WORLD;
    if (lvCountry === 'FR') return LV_CONFIG.shipping.FR;
    if (lvCountry === 'HK') return LV_CONFIG.shipping.HK;
    if (LV_CONFIG.euCountries.includes(lvCountry)) return LV_CONFIG.shipping.EU;
    return LV_CONFIG.shipping.WORLD;
  }

  function showToast(msg) {
    let toast = document.getElementById('lv-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'lv-toast';
      toast.className = 'lv-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.classList.add('is-visible');
    clearTimeout(toast._timeout);
    toast._timeout = setTimeout(() => toast.classList.remove('is-visible'), 2800);
  }

  function shuffleArray(arr) {
    const a = [...arr];
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }

  /* ── CART API ── */
    async function fetchCart() {
    const res = await fetch(LOCALE_PREFIX + '/cart.js');
    if (!res.ok) throw new Error('Cart fetch failed: ' + res.status);
    lvCart = await res.json();
    return lvCart;
  }

  async function updateCartItem(key, quantity) {
    const res = await fetch(LOCALE_PREFIX + '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    lvCart = await res.json();
    return lvCart;
  }

  async function addToCart(variantId, quantity = 1) {
    const res = await fetch(LOCALE_PREFIX + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity })
    });
    if (!res.ok) throw new Error('Add to cart failed');
    await fetchCart();
    return lvCart;
  }

  /* ── SHIPPING BAR ── */
  function renderShippingBar(cart) {
    const threshold = getShippingThreshold();
    const total = cart.total_price;
    const remaining = threshold - total;
    const pct = Math.min(100, Math.max(2, (total / threshold) * 100));
    const bar = document.getElementById('lv-shipping-bar');
    if (!bar) return;
    if (remaining > 0) {
      bar.innerHTML = `
        <div class="lv-shipping-bar__text">
          ${T.shippingProgress.replace('{X}', '<strong>' + formatMoney(remaining) + '</strong>')}
        </div>
        <div class="lv-shipping-bar__track">
          <div class="lv-shipping-bar__fill" style="width:${pct}%"></div>
        </div>`;
    } else {
      bar.innerHTML = `
        <div class="lv-shipping-bar__text"><strong>${T.shippingFree}</strong></div>
        <div class="lv-shipping-bar__track">
          <div class="lv-shipping-bar__fill is-complete" style="width:100%"></div>
        </div>`;
    }
  }

  /* ── CART ITEMS ── */
  function renderCartItems(cart) {
    const container = document.getElementById('lv-cart-items');
    if (!container) return;
    if (!cart.items || cart.items.length === 0) {
      container.innerHTML = `
        <div class="lv-cart-empty">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2"
              d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"/>
          </svg>
          <p>${T.emptyCart}</p>
        </div>`;
      return;
    }
    container.innerHTML = `<div class="lv-cart-items">${cart.items.map(item => `
      <div class="lv-cart-item" data-key="${item.key}">
        <img class="lv-cart-item__image"
          src="${item.image ? item.image.replace('_grande','_medium') : ''}"
          alt="${item.product_title}" loading="lazy">
        <div class="lv-cart-item__info">
          <div class="lv-cart-item__name">${item.product_title}</div>
          ${item.variant_title && item.variant_title !== 'Default Title'
            ? `<div class="lv-cart-item__variant">${item.variant_title}</div>` : ''}
          <div class="lv-cart-item__price">${formatMoney(item.final_line_price)}</div>
          <div class="lv-cart-item__actions">
            <div class="lv-qty">
              <button class="lv-qty__btn lv-qty-minus" data-key="${item.key}">−</button>
              <span class="lv-qty__val">${item.quantity}</span>
              <button class="lv-qty__btn lv-qty-plus" data-key="${item.key}">+</button>
            </div>
            <button class="lv-cart-item__remove" data-key="${item.key}">${T.remove}</button>
          </div>
        </div>
      </div>`).join('')}</div>`;

    container.querySelectorAll('.lv-qty-minus').forEach(btn => {
      btn.addEventListener('click', async () => {
        const item = lvCart.items.find(i => i.key === btn.dataset.key);
        if (!item) return;
        await updateCartItem(btn.dataset.key, Math.max(0, item.quantity - 1));
        await renderDrawer();
      });
    });
    container.querySelectorAll('.lv-qty-plus').forEach(btn => {
      btn.addEventListener('click', async () => {
        const item = lvCart.items.find(i => i.key === btn.dataset.key);
        if (!item) return;
        await updateCartItem(btn.dataset.key, item.quantity + 1);
        await renderDrawer();
      });
    });
    container.querySelectorAll('.lv-cart-item__remove').forEach(btn => {
      btn.addEventListener('click', async () => {
        await updateCartItem(btn.dataset.key, 0);
        await renderDrawer();
      });
    });
  }

  /* ── TOTAL ── */
  function renderTotal(cart) {
    const amountEl = document.getElementById('lv-drawer-total');
    const countEl = document.getElementById('lv-drawer-count');
    if (amountEl) amountEl.textContent = formatMoney(cart.total_price);
    if (countEl) {
      const count = cart.item_count;
      countEl.textContent = count + ' ' + (count > 1 ? T.itemPlural : T.itemSingular);
    }
  }

  /* ── UPSELL ── */
  function shuffleArray(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

async function renderUpsell(cart) {
  const container = document.getElementById('lv-upsell-section');
  if (!container) return;

  const cartProductIds = cart.items.map(i => i.product_id);

  // Cherche une couleur (différente de excludeColor si fourni) qui a à la fois un haut ET un bas
  function findColorMatchedSet(allProducts, excludeColor) {
    const colors = [...new Set(
      allProducts.flatMap(p => (p.tags || []).filter(t => t.startsWith('color-')))
    )].filter(c => c !== excludeColor);
    const shuffledColors = shuffleArray(colors);
    for (const c of shuffledColors) {
      const top = allProducts.find(p => (p.tags || []).includes('type-top') && (p.tags || []).includes(c));
      const bottom = allProducts.find(p => (p.tags || []).includes('type-bottom') && (p.tags || []).includes(c));
      if (top && bottom) return [top, bottom];
    }
    return [];
  }

  let products = [];
  try {
    const res = await fetch(LOCALE_PREFIX + '/collections/all/products.json?limit=50');
    const data = await res.json();
    const allProductsRaw = data.products || [];

    const allTags = cart.items.flatMap(item => {
      const match = allProductsRaw.find(p => p.id === item.product_id);
      return match ? (match.tags || []) : [];
    });

    const hasTop    = allTags.includes('type-top');
    const hasBottom = allTags.includes('type-bottom');
    const hasSet    = allTags.includes('type-set');
    const hasCharm  = allTags.some(t => ['Charm', 'type-charm', 'type-brooch', 'type-bodychain'].includes(t));
    const cartColor = allTags.find(t => t.startsWith('color-')) || null;
    const isCompleteSet = hasSet || (hasTop && hasBottom);

    const allProducts = allProductsRaw.filter(p => !cartProductIds.includes(p.id));

    const charmPool = shuffleArray(
      allProducts.filter(p => {
        const ptags = p.tags || [];
        return ptags.includes('Charm') || ptags.includes('type-charm') || ptags.includes('type-brooch') || ptags.includes('type-bodychain');
      })
    );

    if (isCompleteSet && hasCharm) {
      const [altTop, altBottom] = findColorMatchedSet(allProducts, cartColor);
      products = [altTop, altBottom].filter(Boolean).concat(charmPool).slice(0, 4);

    } else if (isCompleteSet) {
      products = charmPool.slice(0, 4);

    } else if (hasBottom) {
      const matchingTops = cartColor
        ? allProducts.filter(p => (p.tags || []).includes('type-top') && (p.tags || []).includes(cartColor))
        : [];
      products = [...matchingTops.slice(0, 2), ...charmPool].slice(0, 4);

    } else if (hasTop) {
      const matchingBottoms = cartColor
        ? allProducts.filter(p => (p.tags || []).includes('type-bottom') && (p.tags || []).includes(cartColor))
        : [];
      products = [...matchingBottoms.slice(0, 2), ...charmPool].slice(0, 4);

    } else {
      // Panier vide, ou juste un charm -> proposer un ensemble complet (couleur au hasard) + charms
      const [setTop, setBottom] = findColorMatchedSet(allProducts, null);
      products = [setTop, setBottom].filter(Boolean).concat(charmPool).slice(0, 4);
    }

    if (products.length === 0) {
      products = shuffleArray(allProducts).slice(0, 4);
    }
  } catch (e) {
    console.error('[LV Cart] renderUpsell failed:', e);
    container.style.display = 'none';
    return;
  }

  if (products.length === 0) { container.style.display = 'none'; return; }
  container.style.display = '';

  container.innerHTML = `
    <div class="lv-upsell">
      <div class="lv-upsell__title">${T.upsellTitle}</div>
      <div class="lv-upsell__slider">
        ${products.map(p => {
          const img = p.images && p.images[0] ? p.images[0].src : '';
          const priceRaw = p.variants && p.variants[0] ? p.variants[0].price : '0';
          const priceCents = Math.round(parseFloat(priceRaw) * 100);
          return `
          <div class="lv-upsell__card" data-product-handle="${p.handle}">
            <img class="lv-upsell__card-img" src="${img}" alt="${p.title}" loading="lazy">
            <div class="lv-upsell__card-name">${p.title}</div>
            <div class="lv-upsell__card-price">${formatMoney(priceCents)}</div>
            <button class="lv-upsell__card-btn" data-product-handle="${p.handle}">${T.quickView}</button>
          </div>`;
        }).join('')}
      </div>
    </div>`;

  container.querySelectorAll('[data-product-handle]').forEach(el => {
    el.addEventListener('click', () => openQuickView(el.dataset.productHandle));
  });
}


    /* ── RENDER DRAWER ── */
  async function renderDrawer() {
    try {
      await fetchCart();
        } catch (e) {
      console.error('[LV Cart] renderDrawer failed:', e);
      const container = document.getElementById('lv-cart-items');
      if (container) container.innerHTML = `<div class="lv-cart-empty"><p>${T.loadError}</p><p style="font-size:11px;color:#c00;margin-top:8px;">${e.message} — ${LOCALE_PREFIX || '(fr)'}/cart.js</p></div>`;
      const bar = document.getElementById('lv-shipping-bar');
      if (bar) bar.innerHTML = '';
      return;
    }

    renderShippingBar(lvCart);
    renderCartItems(lvCart);
    renderTotal(lvCart);
    await renderUpsell(lvCart);
    updateCartBubble(lvCart.item_count);
  }

  /* ── QUICK VIEW ── */
  async function openQuickView(handle) {
    const qv = document.getElementById('lv-quick-view');
    if (!qv) return;
    qv.innerHTML = '<div class="lv-loading"><div class="lv-spinner"></div></div>';
    qv.classList.add('is-open');
    try {
      const res = await fetch(`${LOCALE_PREFIX}/products/${handle}.js`);
      const product = await res.json();
      lvSelectedVariant = product.variants[0] || null;
      renderQuickView(product);
    } catch (e) {
      qv.innerHTML = `<div style="padding:24px;text-align:center;color:#888;">${T.loadError}</div>`;
    }
  }

  function renderQuickView(product) {
    const qv = document.getElementById('lv-quick-view');
    if (!qv) return;
    const img = product.featured_image || (product.images && product.images[0]) || '';
    const priceCents = product.variants[0] ? parseInt(product.variants[0].price) : 0;
    const hasSizes = product.options &&
      product.options.some(o => ['size','taille','Size','Taille'].includes(o.name));

    qv.innerHTML = `
      <button class="lv-qv__close" id="lv-qv-close">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6 18L18 6M6 6l12 12"/>
        </svg>
      </button>
      <div class="lv-qv__header">
        <img class="lv-qv__img" src="${img}" alt="${product.title}">
        <div class="lv-qv__info">
          <span class="lv-qv__brand">${LV_CONFIG.brandName}</span>
          <span class="lv-qv__name">${product.title}</span>
          <span class="lv-qv__price">${formatMoney(priceCents)}</span>
          <span class="lv-qv__stock">${T.inStock}</span>
        </div>
      </div>
      ${hasSizes ? `
        <div class="lv-qv__size-label">
          ${T.sizeLabel} : <span id="lv-qv-size-display">${lvSelectedVariant && lvSelectedVariant.title !== 'Default Title' ? lvSelectedVariant.title : ''}</span>
        </div>
        <div class="lv-qv__sizes">
          ${product.variants.map(v => `
            <button class="lv-qv__size-btn ${v.id === product.variants[0].id ? 'is-selected' : ''} ${!v.available ? 'is-unavailable' : ''}"
              data-variant-id="${v.id}" data-title="${v.title}" ${!v.available ? 'disabled' : ''}>
              ${v.title}
            </button>`).join('')}
        </div>` : ''}
      <button class="lv-qv__add-btn" id="lv-qv-add">${T.addToCart}</button>`;

    document.getElementById('lv-qv-close').addEventListener('click', closeQuickView);

    qv.querySelectorAll('.lv-qv__size-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        qv.querySelectorAll('.lv-qv__size-btn').forEach(b => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        lvSelectedVariant = product.variants.find(v => v.id == btn.dataset.variantId);
        const display = document.getElementById('lv-qv-size-display');
        if (display) display.textContent = btn.dataset.title;
      });
    });

    document.getElementById('lv-qv-add').addEventListener('click', async () => {
      if (!lvSelectedVariant) return;
      const btn = document.getElementById('lv-qv-add');
      btn.disabled = true;
      btn.textContent = T.adding;
      try {
        await addToCart(lvSelectedVariant.id);
        closeQuickView();
        await renderDrawer();
        showToast(T.added);
      } catch (e) {
        btn.textContent = T.error;
        btn.disabled = false;
      }
    });
  }

  function closeQuickView() {
    const qv = document.getElementById('lv-quick-view');
    if (qv) qv.classList.remove('is-open');
    lvSelectedVariant = null;
  }

  /* ── DRAWER OPEN/CLOSE ── */
  function openDrawer() {
    const drawer = document.getElementById('lv-cart-drawer');
    const overlay = document.getElementById('lv-cart-overlay');
    if (!drawer) return;
    drawer.classList.add('is-open');
    overlay && overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    renderDrawer();
  }

  function closeDrawer() {
    const drawer = document.getElementById('lv-cart-drawer');
    const overlay = document.getElementById('lv-cart-overlay');
    drawer && drawer.classList.remove('is-open');
    overlay && overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  /* ── CART BUBBLE ── */
  function updateCartBubble(count) {
    document.querySelectorAll('.cart-count-bubble').forEach(el => {
      el.textContent = count > 0 ? count : '';
      el.style.display = count > 0 ? '' : 'none';
    });
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = count > 0 ? count : '';
    });
  }

  /* ── INTERCEPT ── */
  function interceptCartNavigation() {
  document.addEventListener('click', function (e) {
    // Checkout — laisser passer sans rien faire
    if (e.target.closest('.lv-drawer__checkout-btn')) {
      e.stopPropagation();
      return;
    }
    const cartTrigger = e.target.closest(
      'a[href="/cart"], cart-icon-bubble, .header__icon--cart'
    );
    if (cartTrigger && !cartTrigger.closest('#lv-cart-drawer')) {
      e.preventDefault();
      e.stopPropagation();
      openDrawer();
    }
  }, false);

  document.addEventListener('cart:refresh', renderDrawer);

  const observer = new MutationObserver(function() {
    const notification = document.querySelector('cart-notification');
    if (notification && notification.classList.contains('active')) {
      notification.classList.remove('active', 'animate');
      openDrawer();
    }
  });
    const notifEl = document.querySelector('cart-notification');
  if (notifEl) observer.observe(notifEl, { attributes: true, attributeFilter: ['class'] });
}

  /* ── FIX LIENS /en/ SUR LE DOMAINE .myshopify.com ── */
  function fixLocalizedLinksForShopifyDomain() {
    const isCustomDomain = /(^|\.)lavagueswimwear\.com$/i.test(window.location.hostname);
    if (isCustomDomain) return; // domaine réel : /en/ fonctionne normalement, on ne touche à rien

    document.addEventListener('click', function (e) {
      const link = e.target.closest('a[href]');
      if (!link) return;
      const href = link.getAttribute('href');
      if (href && (href === '/en' || href.indexOf('/en/') === 0)) {
        e.preventDefault();
        window.location.href = href.replace(/^\/en/, '') || '/';
      }
    }, true);
  }

  /* ── COUNTRY POPUP ── */
  function buildCountryPopup() {
    const popup = document.getElementById('lv-country-popup');
    if (!popup) return;
    if (lvCountry) { popup.remove(); return; }

    const titleEl = popup.querySelector('.lv-country-popup__title');
    const subEl = popup.querySelector('.lv-country-popup__sub');
    const confirmEl = document.getElementById('lv-country-confirm');
    if (titleEl) titleEl.textContent = T.whereAreYou;
    if (subEl) subEl.textContent = T.locationSub;
    if (confirmEl) confirmEl.textContent = T.confirm;

    popup.querySelectorAll('.lv-country-option').forEach(btn => {
      const shippingEl = btn.querySelector('.lv-country-option__shipping');
      if (shippingEl) {
        const thresholds = { FR: '100€', EU: '100€', HK: '80€', WORLD: '160€' };
        shippingEl.textContent = T.freeFrom + ' ' + thresholds[btn.dataset.country];
      }
    });

    setTimeout(() => popup.classList.add('is-open'), 800);

    const defaultBtn = popup.querySelector('[data-country="FR"]');
    if (defaultBtn) { defaultBtn.classList.add('is-selected'); lvCountry = 'FR'; }

    popup.querySelectorAll('.lv-country-option').forEach(btn => {
      btn.addEventListener('click', () => {
        popup.querySelectorAll('.lv-country-option').forEach(b => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        lvCountry = btn.dataset.country;
      });
    });

    if (confirmEl) {
      confirmEl.addEventListener('click', () => {
        localStorage.setItem('lv_country', lvCountry);
        popup.classList.remove('is-open');
        setTimeout(() => popup.remove(), 400);
      });
    }
  }

    /* ── INIT ── */
  function init() {
    interceptCartNavigation();
    fixLocalizedLinksForShopifyDomain();
    buildCountryPopup();

    const overlay = document.getElementById('lv-cart-overlay');
    overlay && overlay.addEventListener('click', () => { closeDrawer(); closeQuickView(); });

    const closeBtn = document.getElementById('lv-cart-close');
    closeBtn && closeBtn.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') { closeDrawer(); closeQuickView(); }
    });

    fetchCart().then(cart => updateCartBubble(cart.item_count));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.LVCart = { open: openDrawer, close: closeDrawer, refresh: renderDrawer };
})();
